import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
  Alert,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledTooltip,
} from "reactstrap";
import Switch from "react-switch";
import classnames from "classnames";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import Dropzone from "react-dropzone";
import { useSelector } from "react-redux";
// Redux
import { withRouter, Link } from "react-router-dom";

// Editable
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
// availity-reactstrap-validation
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
//Constants
import { API_WEB_URLS } from "../../constants/constAPI";
//Store
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";
import {
  Fn_DisplayData,
  Fn_AddEditData,
  Fn_FillListData,
  Fn_ChangeStateValue,
  Fn_DeleteData,
  Fn_GetReport,
} from "../../store/functions";
import AddDeleteTableRowsPrint from "pages/Transaction/AddDeleteTableRowPrint";

export const DateString = dd => {
  let d1 = dd.replace("-", "");
  let d2 = d1.replace("-", "");

  return d2;
};

class pageAddEdit_PrintPartyDiscription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,

      formData: {},
      activeTab: 1,
      passedSteps: [1],
      BrowseImage1: "",
      BrowseImage2: "",
      UserImage: "",
      Signature: "",
      //dropdowns
      membershipType: [],
      maritalStatus: [],
      bloodGroup: [],
      gender: [],
      education: [],
      profession: [],
      relationShip: [],
      nationality: [],
      typeofRegCert: [],
      memberid: 0,
      name: "",
      email: "",
      aid: 0,
      fo3: false,
      Gender: 0,
      MaritalStatus: 0,
      success_msg: false,
      F_MISScheme: 0,
      IsOvertime: false,
      EmpBasic: [],
      PrintParty: [
        {
          F_PrintDiscription: "",
          Rate: "",
        },
      ],
      // Add new state variables for dropdown control
      isYearEnabled: false,
      isMonthEnabled: false,
    };
    this.obj = this;
    this.formTitle = "Print Party Discription";
    this.breadCrumbTitle = "Memberships";
    this.breadCrumbItem = " " + this.formTitle;
    this.API_URL = API_WEB_URLS.MASTER + "/0/token/City";
    this.API_URL_SAVE = API_WEB_URLS.AddEdit + "/0/token";
    this.pushFormName = "/PrintPartyDiscription";
    this.rtPage_Print = "/membersynopsisprint";

    //Event Binding
    this.btnSave_onClick = this.btnSave_onClick.bind(this);
    this.btnCancel_onClick = this.btnCancel_onClick.bind(this);
    this.btnGoBack_onClick = this.btnGoBack_onClick.bind(this);
    this.addrow = this.addrow.bind(this);
    this.editrow = this.editrow.bind(this);
    this.PrintId = React.createRef();
    this.deleterow = this.deleterow.bind(this);
  }

  async deleterow(Id, index) {
    const rows = [...this.state.PrintParty];
    rows.splice(index, 1);
    this.setState({ PrintParty: rows });
   await Fn_DeleteData(
      this.obj,
      Id,
      "Masters/0/token/PrintPartyL",
      "Masters/0/token/PrintPartyL" + "/Id/0"
    );
    
    // Recall data after deletion
    this.callData(
      this.state.formData.F_LedgerMaster,
      this.state.formData.F_YearMaster,
      this.state.formData.F_MonthMaster
    );
  }
  componentDidMount() {
    const obj = JSON.parse( sessionStorage.getItem("authUser"));
    this.setState({
      name: obj.username,
      email: obj.email,
      aid: obj.uid,
      role: obj.role,
    });

    //Filling DropDowns
    Fn_FillListData(
      this.obj,
      "PrintDiscription",
      API_WEB_URLS.MASTER + "/0/token/PrintDiscription/Id/0"
    );
    Fn_FillListData(
      this.obj,
      "Ledger",
      API_WEB_URLS.MASTER + "/0/token/LedgerSudryDebtors/Id/0"
    );
    Fn_FillListData(
      this.obj,
      "YearMaster",
      API_WEB_URLS.MASTER + "/0/token/YearMaster/Id/0"
    );
    Fn_FillListData(
      this.obj,
      "MonthMaster",
      API_WEB_URLS.MASTER + "/0/token/MonthMaster/Id/0"
    );

    const { id } = this.props.match.params;
    if (id) {
      this.setState({ id: id });
      this.breadCrumbItem = "Edit " + this.formTitle;
      Fn_DisplayData(this.obj, id, this.API_URL + "/Id");
    } else {
      this.setState({ id: 0 });
    }
  }

  async btnSave_onClick(event, formData) {
    let vformData1 = new FormData();
    vformData1.append("F_LedgerMaster", formData.F_LedgerMaster);

    Fn_AddEditData(
      this.obj,
      { arguList: { id: 0, formData: vformData1 } },
      "InsertPrintPartyDescriptionH/0/token",
      this.pushFormName,
      true
    );

    let vformData2 = new FormData();
    vformData2.append("F_LedgerMaster", formData.F_LedgerMaster);
    vformData2.append("F_MonthMaster", this.state.formData.F_MonthMaster);
    vformData2.append("F_YearMaster", this.state.formData.F_YearMaster);

    // Add year and month IDs to each PrintParty object
    const updatedPrintParty = this.state.PrintParty.map(item => ({
      ...item,
      F_YearMaster: this.state.formData.F_YearMaster,
      F_MonthMaster: this.state.formData.F_MonthMaster,
    }));
console.log(updatedPrintParty); 

    // Create string in format: Id~F_LedgerMaster~F_PrintDiscription~F_MonthMaster~F_YearMaster~Rate@
    const formattedString = updatedPrintParty.map(item => {
      const id = item.Id || 0; // Use 0 if Id is not present
      const ledgerMaster = item.F_LedgerMaster || formData.F_LedgerMaster || '';
      const printDiscription = item.F_PrintDiscription || '';
      const monthMaster = item.F_MonthMaster || '';
      const yearMaster = item.F_YearMaster || '';
      const rate = item.Rate || 0;
      
      return `${id}~${ledgerMaster}~${printDiscription}~${monthMaster}~${yearMaster}~${rate}`;
    }).join('@') + '@';
    
    console.log("Formatted String:", formattedString);
    vformData2.append("FormattedString", formattedString);
    // vformData2.append("Data", JSON.stringify(updatedPrintParty));


   await Fn_AddEditData(
      this.obj,
      { arguList: { id: 0, formData: vformData2 } },
      "InsertPrintPartyDescriptionL/0/token",
      this.pushFormName,
      true
    );
    
    // Recall data after saving
    this.callData(
      this.state.formData.F_LedgerMaster,
      this.state.formData.F_YearMaster,
      this.state.formData.F_MonthMaster
    );
  }

  btnGoBack_onClick = event => {
    event.preventDefault();
    //this.props.history.goBack();
    this.props.history.push(this.pushFormName);
  };

  btnCancel_onClick = event => {
    event.preventDefault();
    //this.props.history.goBack();
    this.props.history.push(this.pushFormName);
  };

  editrow = (index, evnt) => {
    const { name, value } = evnt.target;

    const rowsInput = [...this.state.PrintParty];
    rowsInput[index][name] = value;

    this.setState({ PrintParty: rowsInput });
  };

  addrow() {
    let Print = {
      F_PrintDiscription: "",
      Rate: "",
    };
    this.setState({ PrintParty: [...this.state.PrintParty, Print] });
  }

  add() {
    this.setState({ save: false, cancel: false, add: true });
    this.setState({
      PrintParty: [
        {
          PrintDiscription: "",
          Rate: "",
        },
      ],
    });
  }

  OnLedgerChange = event => {
    const selectedLedger = event.target.value;

    // Get current month (1-12)
    const currentMonth = new Date().getMonth() + 1;

    // Get current year
    const currentYear = new Date().getFullYear().toString();

    // Find the year matching current year
    const latestYear = this.state.YearMaster
      ? this.state.YearMaster.find(item => item.Name === currentYear)?.Id
      : -1;

    // Reset year and month selections when ledger changes
    this.setState({
      isYearEnabled: selectedLedger !== "-1",
      isMonthEnabled: selectedLedger !== "-1",
      formData: {
        ...this.state.formData,
        F_YearMaster: selectedLedger !== "-1" ? latestYear : "-1",
        F_MonthMaster: selectedLedger !== "-1" ? currentMonth : "-1",
        F_LedgerMaster: selectedLedger,
      },
    });

    this.callData(selectedLedger, latestYear, currentMonth);
  };

  OnYearChange = event => {
    const selectedYear = event.target.value;

    // Enable month dropdown when year is selected
    this.setState({
      isMonthEnabled: selectedYear !== "-1",
      formData: {
        ...this.state.formData,
        F_MonthMaster: selectedYear !== "-1" ? new Date().getMonth() + 1 : "-1",
      },
    });
    this.callData(
      this.state.formData.F_LedgerMaster,
      selectedYear,
      this.state.formData.F_MonthMaster
    );
  };

  OnMonthChange = event => {
    const selectedMonth = event.target.value;

    this.setState({
      formData: {
        ...this.state.formData,
        F_MonthMaster: selectedMonth,
      },
    });
    this.callData(
      this.state.formData.F_LedgerMaster,
      this.state.formData.F_YearMaster,
      selectedMonth
    );
  };

  callData = (F_LedgerMaster, F_YearMaster, F_MonthMaster) => {
    const vformData = new FormData();
    vformData.append("F_LedgerMaster", F_LedgerMaster);
    vformData.append("F_YearMaster", F_YearMaster);
    vformData.append("F_MonthMaster", F_MonthMaster);

    Fn_GetReport(
      this.obj,
      { arguList: { id: 0, formData: vformData } },
      "GetPrintPartyByLedger/0/token",
      "PrintParty",
      true
    );
    const vformData1 = new FormData();
    vformData1.append("F_LedgerMaster", F_LedgerMaster);
    vformData1.append("F_YearMaster", Number(F_YearMaster) );
    vformData1.append("F_MonthMaster", Number(F_MonthMaster) - 1);
    Fn_GetReport(
      this.obj,
      { arguList: { id: 0, formData: vformData1 } },
      "GetPrintPartyByLedger/0/token",
      "PrintPartyArray",
      true
    );
  };

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs
              title={this.breadCrumbTitle}
              breadcrumbItem={this.breadCrumbItem}
            />
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                    {/* <h4 className="card-title mb-4">Basic Wizard</h4> */}
                    <div className="wizard clearfix">
                      <div className="content clearfix">
                        <AvForm
                          className="needs-validation"
                          onValidSubmit={this.btnSave_onClick}
                        >
                          <TabContent
                            activeTab={this.state.activeTab}
                            className="body"
                          >
                            <TabPane tabId={1}>
                              <Row>
                                <Col lg="12">
                                  <Card>
                                    <CardBody>
                                      <h4 className="card-title mb-4"></h4>

                                      <Row>
                                        <Col sm="1" className="mb-3">
                                          <label
                                            htmlFor="country"
                                            className="col-form-label"
                                          >
                                            Party
                                          </label>
                                        </Col>
                                        <Col sm="4">
                                          <AvField
                                            name="F_LedgerMaster"
                                            label=""
                                            onChange={this.OnLedgerChange}
                                            value={
                                              this.state.formData
                                                .F_LedgerMaster === null
                                                ? "-1"
                                                : this.state.formData
                                                    .F_LedgerMaster
                                            }
                                            errorMessage="Select Name"
                                            type="select"
                                            className="form-select"
                                          >
                                            <option
                                              value={-1}
                                              defaultValue
                                              label={"Select Ledger"}
                                            />
                                            {this.state.Ledger
                                              ? this.state.Ledger.map(
                                                  (option, key) => (
                                                    <option
                                                      key={option.Id}
                                                      value={option.Id}
                                                      label={option.Name}
                                                    />
                                                  )
                                                )
                                              : null}
                                          </AvField>
                                        </Col>

                                        <Col sm="1" className="mb-3">
                                          <label
                                            htmlFor="year"
                                            className="col-form-label"
                                          >
                                            Year
                                          </label>
                                        </Col>
                                        <Col sm="2">
                                          <AvField
                                            name="F_YearMaster"
                                            label=""
                                            onChange={this.OnYearChange}
                                            value={
                                              this.state.formData
                                                .F_YearMaster === null
                                                ? "-1"
                                                : this.state.formData
                                                    .F_YearMaster
                                            }
                                            errorMessage="Select Year"
                                            type="select"
                                            className="form-select"
                                            disabled={!this.state.isYearEnabled}
                                          >
                                            <option
                                              value={-1}
                                              defaultValue
                                              label={"Select Year"}
                                            />
                                            {this.state.YearMaster
                                              ? this.state.YearMaster.map(
                                                  (option, key) => (
                                                    <option
                                                      key={option.Id}
                                                      value={option.Id}
                                                      label={option.Name}
                                                    />
                                                  )
                                                )
                                              : null}
                                          </AvField>
                                        </Col>

                                        <Col sm="1" className="mb-3">
                                          <label
                                            htmlFor="month"
                                            className="col-form-label"
                                          >
                                            Month
                                          </label>
                                        </Col>
                                        <Col sm="2">
                                          <AvField
                                            name="F_MonthMaster"
                                            label=""
                                            value={
                                              this.state.formData
                                                .F_MonthMaster === null
                                                ? "-1"
                                                : this.state.formData
                                                    .F_MonthMaster
                                            }
                                            errorMessage="Select Month"
                                            type="select"
                                            className="form-select"
                                            disabled={
                                              !this.state.isMonthEnabled
                                            }
                                            onChange={this.OnMonthChange}
                                          >
                                            <option
                                              value={-1}
                                              defaultValue
                                              label={"Select Month"}
                                            />
                                            {this.state.MonthMaster
                                              ? this.state.MonthMaster.map(
                                                  option => (
                                                    <option
                                                      key={option.Id}
                                                      value={option.Id}
                                                      label={option.Name}
                                                    />
                                                  )
                                                )
                                              : null}
                                          </AvField>
                                        </Col>
                                      </Row>
                                    </CardBody>
                                  </Card>
                                </Col>
                                <Card>
                                  <CardBody>
                                  <Row>
                                    <Col sm="6">
                                        {this.state.formData.F_MonthMaster && this.state.formData.F_YearMaster && 
                                          <h4 style={{textAlign: "center", marginBottom: "15px", color: "#495057"}}>
                                            {this.state.YearMaster?.find(item => item.Id == this.state.formData.F_YearMaster)?.Name} - {this.state.MonthMaster?.find(item => item.Id == this.state.formData.F_MonthMaster-1)?.Name}
                                          </h4>
                                        }
                                    <AddDeleteTableRowsPrint
                                      data={this?.state?.PrintPartyArray || []}
                                      PrintDescription={
                                        this.state.PrintDiscription
                                      }
                                      add={this.addrow}
                                      print={this.PrintId}
                                      edit={this.editrow}
                                      del={this.deleterow}
                                      disabled={true}
                                    />
                                      </Col>

                                      <Col sm="6">
                                        {this.state.formData.F_MonthMaster && this.state.formData.F_YearMaster && 
                                          <h4 style={{textAlign: "center", marginBottom: "15px", color: "#495057"}}>
                                            {this.state.YearMaster?.find(item => item.Id == this.state.formData.F_YearMaster)?.Name} - {this.state.MonthMaster?.find(item => item.Id == this.state.formData.F_MonthMaster)?.Name}
                                          </h4>
                                        }
                                     <AddDeleteTableRowsPrint
                                      data={this.state.PrintParty}
                                      PrintDescription={
                                        this.state.PrintDiscription
                                      }
                                      add={this.addrow}
                                      print={this.PrintId}
                                      edit={this.editrow}
                                      del={this.deleterow}
                                    />
                                      </Col>
                                     
                                    </Row>
                                  
                                  </CardBody>
                                </Card>
                              </Row>
                            </TabPane>
                          </TabContent>
                          <div>
                            <Button
                              type="submit"
                              color="primary"
                              className="mr-1 waves-effect waves-light"
                            >
                              Save
                            </Button>
                            &nbsp;
                            <Button
                              type="button"
                              color="primary"
                              className="mr-1 waves-effect waves-light"
                              onClick={this.btnGoBack_onClick}
                            >
                              Go Back
                            </Button>
                          </div>
                        </AvForm>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default compose(container)(pageAddEdit_PrintPartyDiscription);
